import {Component, OnInit,ViewEncapsulation} from '@angular/core';
import {SmsMessageManageService} from "./smsmessage.service";
import {Router} from "@angular/router";
import {LoginService} from "../login/login.service";
import {FormValidator} from "../form.validator";
import {Offcanvas} from '../form.offcanvas';
import {AppSettings} from "../../config/config";
import {ScriptLoader} from "../script-loader";
import { TranslateService,LangChangeEvent  } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;
declare var momentJs: any;

@Component({
  selector: 'app-smsmessage',
  templateUrl: './smsmessage.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../css/datepicker.css',
    './smsmessage.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [SmsMessageManageService,LoginService,FormValidator,Offcanvas,ScriptLoader,],

})

export class SmsMessageComponent implements OnInit {
  private langChangeSubscription: any;

  academicId = 0;
  getAcademicId = localStorage.getItem('academicInfo');
  getAuthToken = localStorage.getItem('usertoken');
  getSchoolId = localStorage.getItem('schoolinfo');

  academicPermissions = {};
  brand = this.brandService.brand;

  constructor(private router: Router, private loginservice: LoginService, private SmsMessageManageService: SmsMessageManageService, private  formValidator: FormValidator, private offcanvas: Offcanvas, private scriptLoader:ScriptLoader,private translate: TranslateService, private brandService: BrandService) {
  }

  destroyDataTable(table) {
    $('#' + table).DataTable().destroy();
  }

initializeDataTable(tableId: string) {
  setTimeout(() => {
    this.translate.get([
      'dataTables.emptyTable',
      'dataTables.search',
      'dataTables.lengthMenu',
      'dataTables.info',
      'dataTables.infoEmpty'
    ]).subscribe(translations => {
      $('#' + tableId).DataTable({
        order: [[0, 'asc']],
        language: {
          emptyTable: translations['dataTables.emptyTable'],
          search: translations['dataTables.search'],
          lengthMenu: translations['dataTables.lengthMenu'],
          info: translations['dataTables.info'],
          infoEmpty: translations['dataTables.infoEmpty']
        }
      });
    });
  }, 500);
}

  enterClassWiseMessageButton = true;
  smsStudentClassId = 0;

  disableButton() {
    this.enterClassWiseMessageButton = true;
  }

  reasonList = [];

  fetchReason() {
    this.reasonList = [];
    this.SmsMessageManageService.fetchReasonService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.reasonList = data;
        },
       async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  create_Reason = "";
 async createReason(){
    if (!this.formValidator.validateIsDataForNumber(this.create_Reason)) {
      const pleaseEnterReasonTranslation = await firstValueFrom(this.translate.get('pleaseEnterReason')); 
      customToastr(pleaseEnterReasonTranslation, 'error');
      return;
    }
    this.SmsMessageManageService.createReasonForSmsService(this.create_Reason,this.getAuthToken)
      .subscribe(
        async (data: any) => {
              if(data[0].message == "success"){
                $("#createReason_btn").trigger("click");
                this.create_Reason = "";
                this.fetchReason_sms();
                const reasonCreatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('reasonCreatedSuccessfully')); 
                customToastr(reasonCreatedSuccessfullyTranslation, 'success');
              }else if(data[0].message == "Reason_name_AlreadyExist"){
                const reasonNameAlreadyExistTranslation = await firstValueFrom(this.translate.get('reasonNameAlreadyExist')); 
                customToastr(reasonNameAlreadyExistTranslation, 'error');
              }
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  schoolWiseSms = {
    reasonId: 0, message: ""
  };
  classStdList = [];

  fetchClassStandard() {
    this.SmsMessageManageService.fetchClassStandardService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.classStdList = data.classlist;
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }

  schoolClassesSections = [];
  selectedClass = null;
  selectClassFunction(selectedClassId) {
    this.selectedClass = selectedClassId;
    this.schoolClassesSections = [];
    this.SmsMessageManageService.messageAvailableClassSection(this.selectedClass, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          for (var i = 0; i < data.length; i++) {
            this.schoolClassesSections.push(data[i]);
          }
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }


  enableClassWiseMessageButton(classId) {
    this.smsStudentClassId = classId;
    if (classId == 0) {
      this.enterClassWiseMessageButton = true;
    }
    else {
      this.enterClassWiseMessageButton = false;
    }
  }

  classWiseSms = {
    reasonId: 0, message: "", classId: 0
  };

  classWiseEnterMessage() {
    this.classWiseSms = {
      reasonId: 0, message: "", classId: this.smsStudentClassId
    };
    this.fetchReason();
  }

  studentWiseSms = {
    reasonId: 0, message: ""
  };
  studentListForSms = [];
  staffListForSms = [];

  staffWiseEnterMessage(data, staffType) {
    this.getStaffType = staffType;
    this.staffListForSms.push(data.staffId);
    this.schoolWiseSms = {
      reasonId: 0, message: ""
    };
    this.fetchReason();
  }

  studentList = [];
  studentListServer : any;
  fetchReasonToGetAllList=[];
  startFetchingData = false;
  noDataFound = false;
  dataFound = false;
  fetchReason_sms() {
    this.startFetchingData = true;
    this.noDataFound = false;
    this.dataFound = false;
    this.fetchReasonToGetAllList = [];
    this.destroyDataTable('reason_manage_sms_list');
    this.SmsMessageManageService.fetchReasonService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.startFetchingData = false;
          this.fetchReasonToGetAllList = data;
          if(this.fetchReasonToGetAllList.length == 0){
            this.noDataFound = true;
          }
          else {
            this.dataFound = true;
          }
          this.initializeDataTable('reason_manage_sms_list');
        },
        async error => {
          this.startFetchingData = false;
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  update_Reason="";reasonId="";

  getReasonId(reasonId){
    this.reasonId = reasonId.pk_reasonId;
    this.update_Reason = reasonId.reason;
  }
  async updateReason(){
    if (!this.formValidator.validateIsDataForNumber(this.update_Reason)) {
      const pleaseEnterReasonTranslation = await firstValueFrom(this.translate.get('pleaseEnterReason')); 
      customToastr(pleaseEnterReasonTranslation, 'error');
      return;
    }
    this.SmsMessageManageService.updateReasonService(this.reasonId,this.update_Reason,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if(data.status[0].message == "success"){
            $("#update_reason_btn").trigger('click');
            this.fetchReason_sms();
            const reasonUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('reasonUpdatedSuccessfully')); 
            customToastr(reasonUpdatedSuccessfullyTranslation, 'success');
          }else if(data.status[0].message == "Reason name AlreadyExist") {
            const reasonNameAlreadyExistTranslation = await firstValueFrom(this.translate.get('reasonNameAlreadyExist')); 
            customToastr(reasonNameAlreadyExistTranslation, 'error');
          }
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  deleteReason(){
    this.SmsMessageManageService.deleteReasonService(this.reasonId,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if(data.status == true){
            $("#delete_close_btn").trigger('click');
            this.fetchReason_sms();
            const reasonDeletedSuccessfullyTranslation = await firstValueFrom(this.translate.get('reasonDeletedSuccessfully')); 
            customToastr(reasonDeletedSuccessfullyTranslation, 'success');
          }else {
            const reasonNotDeletedTranslation = await firstValueFrom(this.translate.get('reasonNotDeleted')); 
            customToastr(reasonNotDeletedTranslation, 'error');
          }
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  selectedStudentsInTableInSms = [];
  selectAllStudent = false;

  studentSelectedInTable(studentDetails,isSelected){
    for(let i=0; i<this.selectedStudentsInTableInSms.length; i++){
      if(this.selectedStudentsInTableInSms[i].length != this.selectedStudentsInTableInSms.length){
        this.selectAllStudent = false;
      }
    }
    if(isSelected == true){
      let getData = false;
      for(let i=0; i<this.selectedStudentsInTableInSms.length; i++){
        if(this.selectedStudentsInTableInSms[i] == studentDetails.studentId){
          getData = true;
        }
      }
      if(getData == false){
        this.selectedStudentsInTableInSms.push(studentDetails.studentId)
      }
    }
    else {
      for(let i=0; i<this.selectedStudentsInTableInSms.length; i++){
        if(this.selectedStudentsInTableInSms[i] == studentDetails.studentId){
          this.selectedStudentsInTableInSms.splice(i,1);
        }
      }
    }
  }

  fetchStudentListForServerCal(usrTyp, both,tableId,authToken) {
    this.selectedStudentsInTableInSms = [];
    $("#message-student-lists").find('input').prop('checked',false);
    this.selectedForStudentWiseMessage = true;

    /*AJAX CALL TO GET STUDENT LIST*/
    let h = this;

    let pageLength = 10;

    this.translate.get([
      'dataTables.processing'
    ]).subscribe(translations => {
    
    this.studentListServer = $('#' + tableId).DataTable({
      destroy: true,
      language: {
        "processing": `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`
      },
      "processing": true,
      "serverSide": true,
      "pageLength": pageLength,
      "ajax": {
        beforeSend: function (request) {
          request.setRequestHeader("Content-Type", 'application/json');
          request.setRequestHeader("authToken", authToken);
        },

        url: AppSettings.API_ENDPOINT + '/message/fetchStudentDetails',
        type: "POST",
        'data': function (d) {
          return JSON.stringify({
            "app_usr":usrTyp,
            "bothApp_User":both,
            "countFrom": d.start,
            "lengthOf": d.length,
            search: d.search.value,
            sort: d.order
          });
        }
      },
      columnDefs: [
        {
          targets: 1,
          className: 'noVis'
        }
      ],
      "columns": [
        {"data": "studentName"},
        {"data": "class"},
        {"data": "mobileNumber"},
        {"defaultContent":"<div class='btn-group'><button type='button' id='send_selected_students_sms' class='btn-raised ink-reaction btn-info' data-toggle='modal' data-target='#studentWiseSmsModal' aria-expanded='false'>SEND</button></div>",orderable: false},
        {"defaultContent":"<label class='checkbox-inline checkbox-styled checkbox-primary'><input class='studentSelectForSms' id='student-select-check-box' type='checkbox'><span class='checkbox-material'><span class='check'></span></span></label>",orderable: false}
        ],
      "rowCallback": function( row, data, index ) {
        $(row).css({
          'text-align':'left'
        });
        $(row, ".studentSelectForSms").on('change',function () {
          let selectStudent = false;
         if($(row).find(".studentSelectForSms").prop('checked') == true){
           selectStudent = true;
         }
          h.studentSelectedInTable(data,selectStudent);
        });
        $(row, '#send_selected_students_sms').on('click', function () {
          h.fetchReason();
        })

      }
    });

  });
  }

  staffList = [];
  selectedForSelective_StaffWiseMessage = false;

  fetchStaffList(usrTyp, both) {
    this.selectedForSelective_StaffWiseMessage = true;
    this.selectedForDesignationWiseSmsForstaff = false;
    this.selectedForStudentWiseMessage = false;
    this.staffList = [];
    this.destroyDataTable('message-staff-lists');
    this.SmsMessageManageService.fetchStaffListService(usrTyp, both, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.staffList = data;
          this.initializeDataTable('message-staff-lists');
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }

  selectedStudentList = [];
  selectedStaffList = [];
  getStaffType = '';

 async sendStudentWiseSms() {
    if (!this.formValidator.validateIsDataForNumber(this.studentWiseSms.reasonId)) {
      const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
      customToastr(pleaseSelectReasonTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber(this.studentWiseSms.message)) {
      const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
      customToastr(pleaseEnterMessageTranslation, 'error');
      return;
    }
    let studentListForSms = [];
    if (this.selectedStudentsInTableInSms.length == 0) {
      const pleaseSelectAtLeastOneStudentTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtLeastOneStudent')); 
      customToastr(pleaseSelectAtLeastOneStudentTranslation, 'error');
      return;
    }

    let studentSms = {
      messageDetails: this.studentWiseSms,
      studentList: this.selectedStudentsInTableInSms,
      userType: this.userType,
      toWhom: this.toWhom,
      studentDrpDown: this.studentDrpDown

    };
    this.SmsMessageManageService.sendMessageToAllStudentService(studentSms, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if (data.data == true) {
           const messageSentToStudentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentToStudentSuccessfully')); 
           customToastr(messageSentToStudentSuccessfullyTranslation, 'success');
            this.fetchSubscriptionDetails();
            this.selectedStudentsInTableInSms = [];
            $("#smsclose2").trigger('click');
            this.studentListForSms = [];
            this.selectedStudentList = [];
            this.studentList = [];
            this.selectedForStudentWiseMessage = false;
            this.studentWiseSms.reasonId = 0;
            this.studentWiseSms.message = "";
          } else if (data.errorcode == "10038") {
            const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
            customToastr(noNumberFoundToSendSmsTranslation, 'error');
          }
          else {
            const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
            customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }

  async sendStaffWiseSmsSelective() {

    if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
      const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
      customToastr(pleaseSelectReasonTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
      const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
      customToastr(pleaseEnterMessageTranslation, 'error');
      return;
    }
    let staffListForSms = [];
    if (this.getStaffType == 'bulkStaff') {
      staffListForSms = this.selectedStaffList
    }
    else {
      staffListForSms = this.staffListForSms
    }
    let staffSms = {
      messageDetails: this.schoolWiseSms,
      staffList: staffListForSms,
      userType: this.userType,
      toWhom: this.toWhom,
      studentDrpDown: this.studentDrpDown

    };
    this.SmsMessageManageService.sendStaffWiseSmsService(staffSms, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if (data.data == true) {
            const messageSentToStaffSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentToStaffSuccessfully')); 
            customToastr(messageSentToStaffSuccessfullyTranslation, 'success');
            this.fetchSubscriptionDetails();
            $("#smsclose2staff").trigger('click');
            this.staffListForSms = [];
            this.selectedStaffList = [];
            this.staffList = [];
            this.selectedForSelective_StaffWiseMessage = false;
          } else if (data.errorcode == "10038") {
            const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
            customToastr(noNumberFoundToSendSmsTranslation, 'error');
          }
          else {
            const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
            customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
         const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError'));
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }

  showMainPage = false;
  userType = "NONE";
  toWhom = "NONE";
  studentDrpDown = "NONE";
  staffDrpDown = "NONE";
  selectedForStudentWiseMessage = false;

  selectedDesigId;
  selectedForDesignationWiseSmsForstaff = false;

  smsDescription = "";
  smsQuantity = "";

  async sendSmsRequest() {
    if(parseInt(this.smsQuantity) == 0 || !this.formValidator.validateIsDataForNumber(this.smsQuantity)){
      const pleaseProvideSmsQuantityToPurchaseTranslation = await firstValueFrom(this.translate.get('pleaseProvideSmsQuantityToPurchase')); 
      customToastr(pleaseProvideSmsQuantityToPurchaseTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.smsDescription)){
      const pleaseEnterDescriptionTranslation = await firstValueFrom(this.translate.get('pleaseEnterDescription')); 
      customToastr(pleaseEnterDescriptionTranslation, 'error');
      return;
    }
    let data = {
      smsQuantity: this.smsQuantity,
      description: this.smsDescription,
      requestSMS: 'PENDING'
    };
    this.SmsMessageManageService.sendSmsRequestService(data, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if (data.status == true) {
           const smsRequestSuccessfullySentToBluewingsTranslation = await firstValueFrom(this.translate.get('smsRequestSuccessfullySentToBluewings', { brandName: this.brand.name }));
           customToastr(smsRequestSuccessfullySentToBluewingsTranslation, 'success');
            this.smsDescription = "";
            this.smsQuantity = "";
            this.showPendingPage = true;
          }
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }

  showPendingPage = false;
  smsRemaining = "";
  totalSubscriptionMessages = "";
  sentSms = '';
  subscriptionList = [];
  fetchSubscriptionData = true;
  fetchSubscriptionDetails(){
    this.fetchSubscriptionData = true;
    this.subscriptionList = [];
    this.showPendingPage = false;
    this.destroyDataTable('subscriptionListTable');
    this.SmsMessageManageService.fetchSubscriptionDetailsService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.fetchSubscriptionData = false;
          this.subscriptionList = data.subscription_list;
          this.smsRemaining = data.smsRemaining;
          if(data.SubscriptionMessages[0].totalSubscriptionMessages){
            this.totalSubscriptionMessages = data.SubscriptionMessages[0].totalSubscriptionMessages;
            this.sentSms = (parseInt(this.totalSubscriptionMessages) - parseInt(this.smsRemaining)).toString();
          }
          else {
            this.totalSubscriptionMessages = '0';
            this.sentSms = '0';
          }
          for(let i=0; i<this.subscriptionList.length; i++){
            if(this.subscriptionList[i].requestStatus == 'PENDING'){
              this.showPendingPage = true;
              break;
            }
          }
          this.initializeDataTable('subscriptionListTable');
        },
        async error => {
          this.fetchSubscriptionData = false;
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }


  schoolClass = {classId: null, app_User: null, bothApp_User: ""};
  designation = null;

  async sendSmsForSelectedFilter() {


    // School wise selection
    if (this.userType == "APP_USER" && this.toWhom == "STUDENT" && this.studentDrpDown == "SCHOOL_WISE") {
      this.schoolClass.app_User = 1;
      this.schoolClass.bothApp_User = null;
      let data = {
        classId: null,
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown

      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseEnterReasonTranslation = await firstValueFrom(this.translate.get('pleaseEnterReason')); 
        customToastr(pleaseEnterReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendSchoolWiseSms_Service(data, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();
              $("#smsclose").trigger('click')

            }
            else {
             const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
             customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }
    else if (this.userType == "NON_APP_USER" && this.toWhom == "STUDENT" && this.studentDrpDown == "SCHOOL_WISE") {
      this.schoolClass.app_User = 0;
      this.schoolClass.bothApp_User = null;
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      let data1 = {
        classId: null,
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      this.SmsMessageManageService.sendSchoolWiseSms_Service(data1, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();
              $("#smsclose").trigger('click')

            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError'));
             customToastr(internalServiceErrorTranslation, 'error');
          }
        );

    }
    else if (this.userType == "BOTH" && this.toWhom == "STUDENT" && this.studentDrpDown == "SCHOOL_WISE") {
      this.schoolClass.app_User = null;
      this.schoolClass.bothApp_User = "BOTH";
      let data2 = {
        classId: null,
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendSchoolWiseSms_Service(data2, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();

              $("#smsclose").trigger('click')

            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }


    // Class wise selection

    else if (this.userType == "APP_USER" && this.toWhom == "STUDENT" && this.studentDrpDown == "CLASS_WISE") {
      this.schoolClass.app_User = 1;
      this.schoolClass.bothApp_User = null;
      let data = {
        classId: this.classWiseSms.classId,
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        schoolWiseSmsReason: this.classWiseSms.reasonId,
        schoolWiseSmsMessage: this.classWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.classWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.classWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendSchoolWiseSms_Service(data, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();

              $("#smsclose1").trigger('click');

            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }
    else if (this.userType == "NON_APP_USER" && this.toWhom == "STUDENT" && this.studentDrpDown == "CLASS_WISE") {
      this.schoolClass.app_User = 0;
      this.schoolClass.bothApp_User = null;
      if (!this.formValidator.validateIsDataForNumber(this.classWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.classWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      let data1 = {
        classId: this.classWiseSms.classId,
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        schoolWiseSmsReason: this.classWiseSms.reasonId,
        schoolWiseSmsMessage: this.classWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      this.SmsMessageManageService.sendSchoolWiseSms_Service(data1, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();

              $("#smsclose1").trigger('click');

            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );

    }
    else if (this.userType == "BOTH" && this.toWhom == "STUDENT" && this.studentDrpDown == "CLASS_WISE") {
      this.schoolClass.app_User = null;
      this.schoolClass.bothApp_User = "BOTH";
      let data2 = {
        classId: this.classWiseSms.classId,
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        schoolWiseSmsReason: this.classWiseSms.reasonId,
        schoolWiseSmsMessage: this.classWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.classWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.classWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendSchoolWiseSms_Service(data2, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();

              $("#smsclose1").trigger('click');

            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }

    // Student wise selection
    else if (this.userType == "APP_USER" && this.toWhom == "STUDENT" && this.studentDrpDown == "STUDENT_WISE") {
      this.schoolClass.app_User = 1;
      this.schoolClass.bothApp_User = null;
      this.fetchStudentListForServerCal(this.schoolClass.app_User, this.schoolClass.bothApp_User,'message-student-lists',this.getAuthToken);
    }
    else if (this.userType == "NON_APP_USER" && this.toWhom == "STUDENT" && this.studentDrpDown == "STUDENT_WISE") {
      this.schoolClass.app_User = 0;
      this.schoolClass.bothApp_User = null;
      this.fetchStudentListForServerCal(this.schoolClass.app_User, this.schoolClass.bothApp_User,'message-student-lists',this.getAuthToken);
    }
    else if (this.userType == "BOTH" && this.toWhom == "STUDENT" && this.studentDrpDown == "STUDENT_WISE") {
      this.schoolClass.app_User = null;
      this.schoolClass.bothApp_User = "BOTH";
      this.fetchStudentListForServerCal(this.schoolClass.app_User, this.schoolClass.bothApp_User,'message-student-lists',this.getAuthToken);
    }

    // Staff wise selection
    else if (this.userType == "APP_USER" && this.toWhom == "STAFF" && this.staffDrpDown == "SCHOOL_WISE_STAFF") {
      this.schoolClass.app_User = 1;
      this.schoolClass.bothApp_User = null;
      this.designation = null;
      let data = {
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        desig: this.designation,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendMessageToAllStaffServices(data, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();


              $("#smscloseforstaff").trigger('click');
            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }
    else if (this.userType == "NON_APP_USER" && this.toWhom == "STAFF" && this.staffDrpDown == "SCHOOL_WISE_STAFF") {
      this.schoolClass.app_User = 0;
      this.schoolClass.bothApp_User = null;
      this.designation = null;
      let data1 = {
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        desig: this.designation,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendMessageToAllStaffServices(data1, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();

              $("#smscloseforstaff").trigger('click');
            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }
    else if (this.userType == "BOTH" && this.toWhom == "STAFF" && this.staffDrpDown == "SCHOOL_WISE_STAFF") {
      this.schoolClass.app_User = null;
      this.schoolClass.bothApp_User = "BOTH";
      this.designation = null;
      let data2 = {
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        desig: this.designation,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
       this.SmsMessageManageService.sendMessageToAllStaffServices(data2, this.getAuthToken)
         .subscribe(
           async (data: any) =>{
             if(data.errorcode == "10038"){
               const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
               customToastr(noNumberFoundToSendSmsTranslation, 'error');
             }else if(data.data == true){
               const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
               customToastr(messageSentSuccessfullyTranslation, 'success');
               this.fetchSubscriptionDetails();

               $("#smscloseforstaff").trigger('click');
             }
             else {
               const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
               customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
             }
           },
           async error =>{
             const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
             customToastr(internalServiceErrorTranslation, 'error');
           }
         );
    }

    // Staff designation wise selection
    else if (this.userType == "APP_USER" && this.toWhom == "STAFF" && this.staffDrpDown == "DESIGNATION_WISE") {
      this.schoolClass.app_User = 1;
      this.schoolClass.bothApp_User = null;
      let data = {
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        desig: this.selectedDesigId,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendSpecificDesignationService(data, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();


              $("#designationWiseSmsFor_staff").trigger('click');
            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
         async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }
    else if (this.userType == "NON_APP_USER" && this.toWhom == "STAFF" && this.staffDrpDown == "DESIGNATION_WISE") {
      this.schoolClass.app_User = 0;
      this.schoolClass.bothApp_User = null;
      let data1 = {
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        desig: this.selectedDesigId,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendSpecificDesignationService(data1, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();


              $("#designationWiseSmsFor_staff").trigger('click');

            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }
    else if (this.userType == "BOTH" && this.toWhom == "STAFF" && this.staffDrpDown == "DESIGNATION_WISE") {
      this.schoolClass.app_User = null;
      this.schoolClass.bothApp_User = "BOTH";
      let data2 = {
        app_usr: this.schoolClass.app_User,
        bothApp_User: this.schoolClass.bothApp_User,
        desig: this.selectedDesigId,
        schoolWiseSmsReason: this.schoolWiseSms.reasonId,
        schoolWiseSmsMessage: this.schoolWiseSms.message,
        userType: this.userType,
        toWhom: this.toWhom,
        studentDrpDown: this.studentDrpDown
      };
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.reasonId)) {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.schoolWiseSms.message)) {
        const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
        customToastr(pleaseEnterMessageTranslation, 'error');
        return;
      }
      this.SmsMessageManageService.sendSpecificDesignationService(data2, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.errorcode == "10038") {
              const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
              customToastr(noNumberFoundToSendSmsTranslation, 'error');
            } else if (data.data == true) {
              const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
              customToastr(messageSentSuccessfullyTranslation, 'success');
              this.fetchSubscriptionDetails();


              $("#designationWiseSmsFor_staff").trigger('click');

            }
            else {
              const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
              customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
            customToastr(internalServiceErrorTranslation, 'error');
          }
        );
    }

    //Staff wise selection

    else if (this.userType == "APP_USER" && this.toWhom == "STAFF" && this.staffDrpDown == "SELECTIVE_STAFF") {
      this.selectedForDesignationWiseSmsForstaff = false;
      this.schoolClass.app_User = 1;
      this.schoolClass.bothApp_User = null;
      this.fetchStaffList(this.schoolClass.app_User, this.schoolClass.bothApp_User);
    }
    else if (this.userType == "NON_APP_USER" && this.toWhom == "STAFF" && this.staffDrpDown == "SELECTIVE_STAFF") {
      this.schoolClass.app_User = 0;
      this.schoolClass.bothApp_User = null;
      this.fetchStaffList(this.schoolClass.app_User, this.schoolClass.bothApp_User);
    }
    else if (this.userType == "BOTH" && this.toWhom == "STAFF" && this.staffDrpDown == "SELECTIVE_STAFF") {
      this.schoolClass.app_User = null;
      this.schoolClass.bothApp_User = "BOTH";
      this.fetchStaffList(this.schoolClass.app_User, this.schoolClass.bothApp_User);

    }
  }


  // view sms strat
  messageArrayList = [];

  fetchAllSmsForView(tableId,authToken) {
    let h = this;
    let pageLength = 10;
  this.translate.get([
  'dataTables.processing',
  'dataTables.emptyTable',
  'dataTables.search',
  'dataTables.lengthMenu',
  'dataTables.info',
  'dataTables.infoEmpty',
  'dataTables.paginate.next',
  'dataTables.paginate.previous'
  ]).subscribe(translations => {
    this.messageArrayList = $('#' + tableId).DataTable({
      destroy: true,
      language: {
      processing: `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`,
      emptyTable: translations['dataTables.emptyTable'],
      search: translations['dataTables.search'],
      lengthMenu: translations['dataTables.lengthMenu'],
      info: translations['dataTables.info'],
      infoEmpty: translations['dataTables.infoEmpty'],
      paginate: {
        next: translations['dataTables.paginate.next'],
        previous: translations['dataTables.paginate.previous']
      }
      },
      "processing": true,
      "serverSide": true,
      "pageLength": pageLength,
      "ajax": {
        beforeSend: function (request) {
          request.setRequestHeader("Content-Type", 'application/json');
          request.setRequestHeader("authToken", authToken);
        },
        url: AppSettings.API_ENDPOINT + '/message/viewSMS',
        type: "POST",
        'data': function (d) {
          return JSON.stringify({
            "countFrom": d.start,
            "lengthOf": d.length,
            search: d.search.value,
            sort: d.order
          });
        }
      },
      columnDefs: [
        {
          targets: 1,
          className: 'noVis'
        }
      ],
      "order": [[ 0, "desc" ]],
      "columns": [
        {"data": "fkMessageWebId", visible:false},
        {"data": "createdOn"},
        {"data":"receiver"},
        {"data": "message_title", "class":"message_title"},
        {"data": "opening_sms_count"},
        {"data": "closing_sms_count"},
        {"data": "MessageCount"},
        { defaultContent: `<span id='clicked-on-view-sms-details' data-toggle='modal' data-target='#viewDetailsForSms' class='view_sms_det' style='color:var(--brand-primary-color);border-bottom: 1px solid;cursor: pointer;letter-spacing:1px;'>${translations['dataTables.viewDetails']}</span>`,orderable: false},

      ],
      "rowCallback": function( row, data, index ) {
        $(row,".message_title").attr('title',data.message);
        $(".view_sms_det",row).on('click',function(e){
          h.getMessageList(data)
        });
      }
    });
  })
  }

  studentListTable = false;
  staffListTable = false;
  everyoneTableList = false;
  dataForSms;
  getMessageList(data){
    this.dataForSms= data;
    this.studentListTable = false;
    this.staffListTable = false;
    this.everyoneTableList = false;
    if(data.receiver == 'STUDENT'){
      this.studentListTable = true;
      this.getStudentMessageList(data,'View_sms_details_new',this.getAuthToken);
    }
    else if(data.receiver == 'STAFF') {
      this.staffListTable = true;
      this.getMessageListForStaff(data,'staffListMessageTable',this.getAuthToken);
    }
    else if(data.receiver == 'EVERYONE'){
      this.everyoneTableList = true;
      this.getMessageToEveryone(data,'everyoneMessageTable',this.getAuthToken);
    }
  }
  studentMessageList : any;
  staffMessageList : any;
  messageListForEveryone : any;


  getStudentMessageList(student,tableId,authToken){

    /*AJAX CALL TO GET STUDENT LIST*/
    let h = this;

    let pageLength = 10;
    this.translate.get([
      'dataTables.processing',    
    ]).subscribe(translations => {
    this.studentMessageList = $('#' + tableId).DataTable({
      destroy: true,
      language: {
        "processing": `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`
      },
      "processing": true,
      "serverSide": true,
      "pageLength": pageLength,
      "ajax": {
        beforeSend: function (request) {
          request.setRequestHeader("Content-Type", 'application/json');
          request.setRequestHeader("authToken", authToken);
        },

        url: AppSettings.API_ENDPOINT + '/message/viewSMSViewDetailsForStudent',
        type: "POST",
        'data': function (d) {
          return JSON.stringify({
            "messageId":student.fkMessageWebId,
            "toWhom":student.receiver,
            "countFrom": d.start,
            "lengthOf": d.length,
            search: d.search.value,
            sort: d.order
          });
        }
      },
      columnDefs: [
        {
          targets: 1,
          className: 'noVis'
        }
      ],
      "columns": [
        {"class": "studentId", "data": "studentName"},
        {"data": "rollNumber"},
        {"data": "class"},
        {"data": "mobileNumber"},
        {"data":"smsStatus",orderable:false},
      ],
      "rowCallback": function( row, data, index ) {


      }
    });
  });
  }

  getMessageListForStaff(staff,tableId,authToken){
    let h = this;
    let pageLength = 10;
    this.translate.get([
      'dataTables.processing',

    ]).subscribe(translations => {
    this.staffMessageList = $('#' + tableId).DataTable({
      destroy: true,
      language: {
        "processing": `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`
      },
      "processing": true,
      "serverSide": true,
      "pageLength": pageLength,
      "ajax": {
        beforeSend: function (request) {
          request.setRequestHeader("Content-Type", 'application/json');
          request.setRequestHeader("authToken", authToken);
        },
        url: AppSettings.API_ENDPOINT + '/message/viewSMSViewDetailsForStaff',
        type: "POST",
        'data': function (d) {
          return JSON.stringify({
            "messageId":staff.fkMessageWebId,
            "toWhom":staff.receiver,
            "countFrom": d.start,
            "lengthOf": d.length,
            search: d.search.value,
            sort: d.order
          });
        }
      },
      columnDefs: [
        {
          targets: 1,
          className: 'noVis'
        }
      ],
      "columns": [
        {"class":"staffId", "data": "staffName"},
        {"data": "mob"},
        {"data": "designation"},
        {"data":"smsStatus",orderable:false},
      ],
      "rowCallback": function( row, data, index ) {


      }
    });
  });
  }

  getMessageToEveryone(user_data,tableId,authToken){
    let h = this;
    let pageLength = 10;
    this.translate.get([
      'dataTables.processing',

    ]).subscribe(translations => {
    
    this.messageListForEveryone = $('#' + tableId).DataTable({
      destroy: true,
      language: {
        "processing": `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`
      },
      "processing": true,
      "serverSide": true,
      "pageLength": pageLength,
      "ajax": {
        beforeSend: function (request) {
          request.setRequestHeader("Content-Type", 'application/json');
          request.setRequestHeader("authToken", authToken);
        },
        url: AppSettings.API_ENDPOINT + '/message/viewSMSDetailsForEveryone',
        type: "POST",
        'data': function (d) {
          return JSON.stringify({
            "messageId":user_data.fkMessageWebId,
            "toWhom":user_data.receiver,
            "countFrom": d.start,
            "lengthOf": d.length,
            search: d.search.value,
            sort: d.order
          });
        }
      },
      columnDefs: [
        {
          targets: 1,
          className: 'noVis'
        }
      ],
      "columns": [
        {"data":"pkmessage_web_Id",visible:false},
        {"data":"userName"},
        {"data":"userType"},
        {"data":"mobileNumber"},
        {"data":"userPosition"},
        {"data":"smsStatus"},
      ],
      "rowCallback": function( row, data, index ) {


      }
    });
  });
  }

  checkSmsDescriptionLength(name) {
    if (!name) {
      return name;
    }
    else if (name.length > 40) {
      return $.trim(name).substring(0, 37)+'...'
    } else {
      return name;
    }
  }
  validateNumber(){
    this.smsQuantity = this.smsQuantity.replace(/[^0-9]/g,"");
  }
  descriptionLength = 250;
  checkDescriptionLength(){
    this.descriptionLength = 250;
    this.descriptionLength = this.descriptionLength - this.smsDescription.length;
  }

  openCanvas(){
    this.offcanvas.handleOffcanvasOpen('#particularSmsCanvas');
  }
  isValidToken() {
    var isValidToken = false;
    var isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if (data.errorcode == 10010) {
            this.router.navigate(['/suspended']);
          }
          else if (isValidToken == true) {
            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
              .subscribe(
                (isValidData: any) => {
                  isValidSchool = isValidData.schoolExist;
                  this.getSchoolId = localStorage.getItem('schoolinfo');
                  //this.schoolId=20;

                  if (isValidSchool != 1) {
                    this.router.navigate(['/login']);
                  } else {
                    this.fetchSubscriptionDetails();
                  }
                },
                error => {
                  }
              );
          } else {
            this.router.navigate(['/login']);
          }
        },
        error => {

          }
      );
  }

  ngOnInit() {
    this.scriptLoader.loadScript($, "DASHBOARD")
    this.isValidToken();
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.refreshSmsDataTable();
    });
  }
  current_tab = 'SEND_SMS';
  total_user_count = '';
  showMessagePage(){
    this.showMainPage = this.current_tab == 'SEND_SMS';
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

refreshSmsDataTable() {
  const tableId = 'message_sms_lists';
  const table = $('#' + tableId).DataTable();
  if (table) table.destroy();
  this.fetchAllSmsForView(tableId, this.getAuthToken);
}

appUserType = 'BOTH_USER';

  getUserCount(){
    this.total_user_count = "";
    let classList = [];
    if(this.studentType == 'CLASS_WISE'){
      for(let i=0; i<this.addClassForSms.length; i++){
        classList.push(this.addClassForSms[i].classId);
      }
    }
    else {
      classList = [];
    }
    this.SmsMessageManageService.getUserCountService(this.sendTo,this.appUserType,classList,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.total_user_count = data.total_count;
        },
        async error =>{
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  sendTo = "";
  sendSmsForm = false;
  studentType = 'NONE';
  showClassList = false;
  showDropDownForStudent = false;
  smsSendTo(){
    this.sendSmsForm = false;
    this.showDropDownForStudent = false;
    this.showClassList = false;
    this.getUserCount();
    if(this.sendTo == 'everyone' || this.sendTo == 'staff'){
      this.sendSmsForm = true;
    }
    else if(this.sendTo == 'student'){
      this.addClassForSms = [];
      this.getClassesOfSchool();
      this.showDropDownForStudent = true;
      if(this.studentType == 'ALL_STUDENT'){
        this.sendSmsForm = true;
      }
      else if(this.studentType == 'CLASS_WISE') {
        this.showClassList = true;
      }
    }
    else {
      this.sendSmsForm = false;
    }
  }
  sendSmsTab(){
    this.sendTo = "";
    this.sendSmsForm = false;
    this.showDropDownForStudent = false;
    this.showClassList = false;
    this.studentType = 'NONE';
    this.addClassForSms = [];
  }
  getClassSectionList = [];
  getClassesOfSchool(){
    this.getClassSectionList = [];
    this.SmsMessageManageService.getClassesOfSchoolService(this.getAuthToken)
      .subscribe(
        (data: any) =>{
          if(data && data.length > 0){
            for(let i=0; i<data.length; i++){
              this.getClassSectionList.push({classId:data[i].classId,className:data[i].ClassStandard+'-'+data[i].classDivision})
            }
          }
        },
        async error =>{
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  addClassForSms = [];
  getClassListForSms(classId){
    for(let i=0; i<this.getClassSectionList.length; i++){
      if(this.getClassSectionList[i].classId == classId){
        this.addClassForSms.push(this.getClassSectionList[i]);
        this.getClassSectionList.splice(i,1);
        this.sendSmsForm = true;
      }
    }
    this.getUserCount();
  }
  removeClass(classId){
    for(let i=0; i<this.addClassForSms.length; i++){
      if(this.addClassForSms[i].classId == classId){
        this.getClassSectionList.push(this.addClassForSms[i]);
        this.addClassForSms.splice(i,1);
      }
    }
    this.getUserCount();
    if(this.addClassForSms.length == 0){
      this.sendSmsForm = false;
    }
  }
}
